import styled from "styled-components";
import styledSystem from "helpers/styledSystem";

export const BaseText = styledSystem(styled.p`
  display: block;
  box-sizing: border-box;
  margin-bottom: 0;
  word-break: break-word;
`);
